import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Analisis/obtenerTokenMagavision`, method: 'GET', body: null})
}
